import React from "react";
import { FaRadiation } from "react-icons/fa";

const Services = () => {
  return (
    <section className="Services mt-10">
      <div className="w-100">
        <h1 className="text-center fw-bold text-white">Cosa otterrai con il nostro progetto</h1>
        <p className="mt-3 text-center fs-5 text-white mb-5">
        Partecipa alla digitalizzazione del paese
        </p>

        <div className="canvas mt-3">
          <p className="fs-3 text-center text-white">Se il tuo immobile fa al caso nostro, troveremo un accordo grazie al quale tu potrai percepire i proventi derivanti dalla locazione dell'area oppure beneficiare di servizi e/o forniture di vario genere.</p>
        </div>
      </div>
    </section>
  );
};

export default Services;
